import { GET_SINGLE_TERMS_AND_PRIVACY, GET_TERMS_AND_PRIVACY } from "../actions/types";
const initialState = {
  termsAndPrivacy: [],
  singleTermsAndPrivacy: {}
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_TERMS_AND_PRIVACY:
      return {
        ...state,
        termsAndPrivacy: payload,
      };
    case GET_SINGLE_TERMS_AND_PRIVACY:
      return {
        ...state,
        singleTermsAndPrivacy: payload,
      }
    default:
      return state;
  }
}
